/**
 *
 * QuestionCard
 *
 */

import React, { Fragment } from "react"
import "./index.less"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

/* eslint-disable react/prefer-stateless-function */
class QuestionCard extends React.Component {
  id = Math.random()
    .toString(36)
    .substr(2, 9)

  state = {
    showMore: false,
    activeMore: false,
    totalHeight: null,
    lessHeight: null,
    maskHeight: null,
    maskHeightLess: null,
  }

  UNSAFE_componentWillMount() {
    window.addEventListener("resize", this.countLine)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.countLine)
  }

  componentDidUpdate(nextProps) {
    if (nextProps.description != this.props.description) {
      this.countLine()
    }
  }

  componentDidMount() {
    const that = this
    setTimeout(() => {
      that.countLine()
    }, 200)
  }

  countLine = () => {
    const el = document.querySelector(
      `#${CSS.escape(this.id)} .QuestionCardComponent-text`
    )
    var elHeader = document.querySelector(
      `#${CSS.escape(this.id)} .QuestionCardComponent-title`
    )
    if (el && elHeader) {
      const lineHeight = parseInt(el.style.lineHeight)
      const lines = el.getClientRects().length
      var elHeader = elHeader.clientHeight
      this.setState({
        showMore: lines > 3,
        totalHeight: lines * lineHeight + 18 + 40 + elHeader, // 18 linehegit + 40 paddingb y t + 25 header
        lessHeight: lineHeight * 3 + 40 + elHeader,
        maskHeight: lines * lineHeight, // 18 linehegit
        maskHeightLess: lineHeight * 3,
      })
    }
  }

  viewMore = (activeMore) => {
    this.setState({ activeMore: !activeMore })
  }

  render() {
    const { title, description } = this.props
    const {
      showMore,
      lessHeight,
      totalHeight,
      activeMore,
      maskHeight,
      maskHeightLess,
    } = this.state
    const iconMore = (
      <svg
        width="8"
        height="6"
        viewBox="0 0 8 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8 0.927621C8 1.02151 7.96664 1.11638 7.89991 1.19561L4.34573 5.34058C4.2592 5.44132 4.12887 5.5 3.99021 5.5C3.85259 5.5 3.72122 5.44132 3.63573 5.34058L0.100316 1.21321C-0.0571143 1.02934 -0.0258367 0.760375 0.17017 0.61269C0.366176 0.465004 0.652888 0.494346 0.810318 0.678219L3.99125 4.39089L7.18991 0.659636C7.34734 0.475763 7.63405 0.446421 7.83006 0.594107C7.94162 0.679197 8 0.802431 8 0.927621Z"
          fill="#378FEE"
        />
      </svg>
    )
    const iconLess = (
      <svg
        width="8"
        height="5"
        viewBox="0 0 8 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8 4.57238C8 4.47849 7.96664 4.38362 7.89991 4.30439L4.34573 0.159422C4.2592 0.0586829 4.12887 0 3.99021 0C3.85259 0 3.72122 0.0586829 3.63573 0.159422L0.100316 4.28679C-0.0571143 4.47066 -0.0258367 4.73963 0.17017 4.88731C0.366176 5.035 0.652888 5.00565 0.810318 4.82178L3.99125 1.10911L7.18991 4.84036C7.34734 5.02424 7.63405 5.05358 7.83006 4.90589C7.94162 4.8208 8 4.69757 8 4.57238Z"
          fill="#378FEE"
        />
      </svg>
    )

    return (
      <div
        className="QuestionCardComponent"
        id={this.id}
        style={{
          height: showMore
            ? activeMore
              ? totalHeight
              : lessHeight
            : totalHeight,
          overflow: "hidden",
        }}>
        <div className="QuestionCardComponent-title">{title}</div>
        <div
          className="QuestionCardComponent-mask"
          style={{
            height: showMore
              ? activeMore
                ? maskHeight
                : maskHeightLess
              : maskHeight,
          }}>
          <div
            className="QuestionCardComponent-text"
            style={{ lineHeight: "18px" }}>
            {description}
          </div>
        </div>
        {showMore && !activeMore && (
          <Fragment>
            <div className="QuestionCardComponent-text-moreDiv">
              ...{" "}
              <span
                className="QuestionCardComponent-text-more"
                onClick={() => this.viewMore(activeMore)}>
                {" "}
                Ver más {iconMore}{" "}
              </span>
            </div>
          </Fragment>
        )}
        {activeMore && (
          <Fragment>
            <span
              className="QuestionCardComponent-text-less"
              onClick={() => this.viewMore(activeMore)}>
              {" "}
              Ver menos {iconLess}{" "}
            </span>
          </Fragment>
        )}
      </div>
    )
  }
}

QuestionCard.propTypes = {}

export default QuestionCard
